const images = {
  logo: require("./Logo.png"),
  noImage: require("./AvatarEmty.png"),
};
export default images;
